import styled, { keyframes } from 'styled-components';

const opacityAnimation = keyframes`
  0% {
    opacity: 0;
    background: transparent;
  }

  50% {
    opacity: 1;
    background: var(--blue);
  }

  100% {
    opacity: 0;
  }
`;

const ResultsLoadingIndicatorContainer = styled.div`
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  grid-gap: 10px;
  padding: 10px;
  display: grid;
  position: relative;
  div {
    aspect-ratio: 1 / 1;
  }
  div:nth-child(8) {
    display: none;
  }
  div:nth-child(7) {
    display: none;
  }
  div:nth-child(6) {
    display: none;
  }
  div:nth-child(5) {
    display: none;
  }
  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  }
`;

const ResultsLoadingIndicator = styled.div`
  width: 100%;
  height: 100%;
  animation: ${opacityAnimation} 2s linear infinite;
  opacity: 0;
  @media screen and (min-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

const AlbumResultsLoader = ({ $columnSize, $width, $height }) => (
  <ResultsLoadingIndicatorContainer $columnSize={$columnSize}>
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '0.1s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '0.3s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '0.6s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '0.9s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '1.2s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '1.5s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '1.8s' }} />
    <ResultsLoadingIndicator $width={$width} $height={$height} style={{ animationDelay: '2.1s' }} />
  </ResultsLoadingIndicatorContainer>
);

export default AlbumResultsLoader;
